var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErroricon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.8512 16.5876L12.5624 56.922C12.1418 57.6504 11.9202 58.4766 11.9202 59.3178C11.9201 60.1589 12.1414 60.9852 12.562 61.7137C12.9825 62.4422 13.5874 63.0471 14.3159 63.4676C15.0443 63.8882 15.8707 64.1095 16.7118 64.1095H63.2856C64.1267 64.1095 64.953 63.8882 65.6815 63.4676C66.4099 63.0471 67.0148 62.4422 67.4354 61.7137C67.8559 60.9852 68.0773 60.1589 68.0772 59.3178C68.0771 58.4766 67.8556 57.6504 67.4349 56.922L44.1487 16.5876C43.7282 15.8594 43.1235 15.2546 42.3952 14.8342C41.6669 14.4137 40.8408 14.1924 39.9999 14.1924C39.159 14.1924 38.3329 14.4137 37.6047 14.8342C36.8764 15.2546 36.2717 15.8594 35.8512 16.5876Z",
    fill: "#FFB400"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3037 29.0276H39.6962C38.2005 29.0276 36.988 30.2401 36.988 31.7357V44.6801C36.988 46.1757 38.2005 47.3882 39.6962 47.3882H40.3037C41.7993 47.3882 43.0118 46.1757 43.0118 44.6801V31.7357C43.0118 30.2401 41.7993 29.0276 40.3037 29.0276Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9999 57.6544C41.6633 57.6544 43.0118 56.3059 43.0118 54.6425C43.0118 52.9791 41.6633 51.6306 39.9999 51.6306C38.3365 51.6306 36.988 52.9791 36.988 54.6425C36.988 56.3059 38.3365 57.6544 39.9999 57.6544Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErroricon);
export default __webpack_public_path__ + "static/media/erroricon.1189fabbb66f73d37b0d2ce4f76c5851.svg";
export { ForwardRef as ReactComponent };